module.exports = __webpack_public_path__ + "static/media/bamboo.e9cab160.png";